import {useState} from "react";
import {Dropdown} from "primereact/dropdown";
import {InputNumber} from "primereact/inputnumber";
import {RadioButton} from "primereact/radiobutton";
import {toast} from "react-toastify";
import MaterialFields from "./MaterialFields";
import {
	useCategories,
	useColors,
	useFurnitures,
	useSets,
	useTrees,
} from "../../../hooks/useCatalog";
import {useCreateVipuskForSupermarket} from "../../../hooks/useVipusk";

const StoreTab = ({onVipuskCreated}) => {
	const [selectedCategory, setSelectedCategory] = useState();
	const [selectedSet, setSelectedSet] = useState();
	const [selectedStoreFurniture, setSelectedStoreFurniture] = useState();
	const [selectedColor, setSelectedColor] = useState();
	const [selectedTree, setSelectedTree] = useState();
	const [storeAmount, setStoreAmount] = useState(0);
	const [position, setPosition] = useState(null);
	const [marketPackage, setMarketPackage] = useState(0);
	const [marketMirror, setMarketMirror] = useState(0);
	const [marketMirrorWood, setMarketMirrorWood] = useState(0);
	const [marketLxdf, setMarketLxdf] = useState(0);

	// api hooks
	const {data: categories = []} = useCategories();
	const {data: trees = [], isLoading: isLoadingTrees} = useTrees();
	const {data: colors = [], isLoading: isLoadingColors} = useColors();
	const {data: sets = [], isLoading: isLoadingSets} = useSets(
		selectedCategory?.id,
	);
	const {data: storeFurniture = [], isLoading: isLoadingStoreFurniture} =
		useFurnitures(selectedSet?.id);
	const {mutateAsync: createVipuskForSupermarket} =
		useCreateVipuskForSupermarket();

	const resetMarketMaterials = () => {
		setMarketPackage(0);
		setMarketMirror(0);
		setMarketMirrorWood(0);
		setMarketLxdf(0);
	};

	const materialFields = [
		{label: "Упаковка сони", value: marketPackage, onChange: setMarketPackage},
		{label: "Ойна", value: marketMirror, onChange: setMarketMirror},
		{
			label: "Ойна учун таянч",
			value: marketMirrorWood,
			onChange: setMarketMirrorWood,
		},
		{label: "Lxdf", value: marketLxdf, onChange: setMarketLxdf},
	];

	const positions = [
		{value: 1, label: "I"},
		{value: 2, label: "II"},
		{value: 3, label: "III"},
	];

	const generateStoreSerial = async () => {
		try {
			const response = await createVipuskForSupermarket({
				treeId: selectedTree.id,
				colorId: selectedColor.id,
				positionId: position,
				furnitureId: selectedStoreFurniture.id,
				amount: storeAmount,
				package_quantity: marketPackage,
				glass_quantity: marketMirror,
				glass_wood_quantity: marketMirrorWood,
				lxdf_quantity: marketLxdf,
			});
			onVipuskCreated(response.data);
			resetMarketMaterials();
		} catch (error) {
			console.log("Error:", error);
			toast.error("Серия номер яратишда хатолик!");
		}
	};

	return (
		<div className="w-full">
			<div className="grid grid-cols-1 gap-4 md:grid-cols-2">
				<div className="flex flex-col">
					<label className="text-sm mb-1.5 font-semibold">Категория</label>
					<Dropdown
						value={selectedCategory}
						onChange={(e) => setSelectedCategory(e.value)}
						options={categories}
						optionLabel="name"
						placeholder="Категория танланг"
						className="w-full border border-gray-300 rounded-lg"
					/>
				</div>

				<div className="flex flex-col">
					<label className="text-sm mb-1.5 font-semibold">Комплект</label>
					<Dropdown
						value={selectedSet}
						onChange={(e) => setSelectedSet(e.value)}
						options={sets}
						optionLabel="name"
						placeholder="Комплект танланг"
						className="w-full border border-gray-300 rounded-lg"
						disabled={!sets.length}
						loading={isLoadingSets}
						filter
					/>
				</div>
			</div>

			<div className="grid grid-cols-1 gap-4 mt-8 md:grid-cols-2">
				<div className="flex flex-col">
					<label className="text-sm mb-1.5 font-semibold">Мебель</label>
					<Dropdown
						value={selectedStoreFurniture}
						onChange={(e) => setSelectedStoreFurniture(e.value)}
						options={storeFurniture}
						optionLabel="name"
						placeholder="Мебель танланг"
						className="w-full border border-gray-300 rounded-lg"
						disabled={!storeFurniture.length}
						loading={isLoadingStoreFurniture}
						filter
					/>
				</div>

				<div className="flex flex-col">
					<label className="text-sm mb-1.5 font-semibold">Сони</label>
					<InputNumber
						value={storeAmount}
						onChange={(e) => setStoreAmount(e.value)}
						className="w-full"
						inputClassName="border p-2 rounded-lg border-gray-300"
						style={{
							borderRadius: "0.5rem",
						}}
					/>
				</div>
			</div>

			<div className="grid grid-cols-1 gap-4 mt-8 mb-8 md:grid-cols-3">
				<div className="flex flex-col">
					<label className="text-sm mb-1.5 font-semibold">Ранги</label>
					<Dropdown
						value={selectedColor}
						onChange={(e) => setSelectedColor(e.value)}
						options={colors}
						placeholder="Ранги танланг"
						optionLabel="name"
						className="w-full border border-gray-300 rounded-lg"
						disabled={!colors.length}
						loading={isLoadingColors}
						filter
					/>
				</div>
				<div className="flex flex-col">
					<label className="text-sm mb-1.5 font-semibold">Дерево</label>
					<Dropdown
						value={selectedTree}
						onChange={(e) => setSelectedTree(e.value)}
						options={trees}
						optionLabel="name"
						placeholder="Дарахт танланг"
						className="w-full border border-gray-300 rounded-lg"
						disabled={!trees.length}
						loading={isLoadingTrees}
					/>
				</div>

				<div className="flex flex-col">
					<label className="text-sm mb-1.5 font-semibold">Позиция</label>
					<div className="flex flex-wrap gap-3 mt-2">
						{positions.map(({value, label}) => (
							<div key={value} className="flex align-items-center">
								<RadioButton
									className={value === 1 ? "opacity-100 !w-5 !h-5" : ""}
									inputId={`ingredient${value}`}
									onChange={() => setPosition(value)}
									checked={position === value}
								/>
								<label htmlFor={`ingredient${value}`} className="ml-2">
									{label}
								</label>
							</div>
						))}
					</div>
				</div>
			</div>

			<MaterialFields
				fields={materialFields}
				containerClassName="grid grid-cols-1 gap-4 mb-8 md:grid-cols-2 lg:grid-cols-4"
			/>

			<button
				className="w-full px-4 py-3 text-white rounded-md bg-blue"
				onClick={generateStoreSerial}
				disabled={
					!selectedStoreFurniture ||
					!storeAmount ||
					!selectedColor ||
					!selectedTree
				}>
				Серия рақам яратиш
			</button>
		</div>
	);
};

export default StoreTab;
